import useSettingsObservationTypeEditRoute_AddFunctionType from "../api/useSettingsObservationTypeEditRoute_AddFunctionType";
import useSettingsObservationTypeEditRoute_Delete from "../api/useSettingsObservationTypeEditRoute_Delete";
import useSettingsObservationTypeEditRoute_GetById from "../api/useSettingsObservationTypeEditRoute_GetById";
import useSettingsObservationTypeEditRoute_RemoveFunctionType from "../api/useSettingsObservationTypeEditRoute_RemoveFunctionType";
import useSettingsObservationTypeEditRoute_Update from "../api/useSettingsObservationTypeEditRoute_Update";

export function useSettingsObservationTypeData(observationTypeId: string) {
    const queryData = useSettingsObservationTypeEditRoute_GetById(observationTypeId);
    const updateMutation = useSettingsObservationTypeEditRoute_Update();
    const deleteMutation = useSettingsObservationTypeEditRoute_Delete();

    const addFunctionTypeMutation = useSettingsObservationTypeEditRoute_AddFunctionType();
    const removeFunctionTypeMutation = useSettingsObservationTypeEditRoute_RemoveFunctionType();

    return {
        queryData,
        updateMutation,
        deleteMutation,
        addFunctionTypeMutation,
        removeFunctionTypeMutation,
    };
}
